import { OptionalGroupRepository } from "core/repository";
import Big from "big.js";
import OptionalGroupFormCreatePresenter from "./create.presenter";

class OptionalGroupFormEditPresenter extends OptionalGroupFormCreatePresenter {
  initialState() {
    return {
      ...super.initialState(),
      creating: false,
      title: "Editar Grupo de Opcionais"
    };
  }

  async onStart() {
    await super.onStart();
  }

  async loadOptionalGroup() {
    const optionalGroupUuid = this.routeParams.optionalGroupUuid;
    const result = await OptionalGroupRepository.getOptionalGroup(
      optionalGroupUuid
    );
    let form = result.data;
    form.optionals = form.optionals.map(opt => {
      return {
        mandatory: opt.mandatory || false,
        name: opt.name || "",
        value: Big(opt.value || form.value)
          .div(100)
          .toFixed(2)
      };
    });

    if (result.success) {
      this.enqueue({ form });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oooops...",
        content:
          "Não conseguimos carregar este grupo de opcionais! Tente novamente em alguns minutos."
      });
    }
    return result;
  }

  async callRepository(params) {
    const optionalGroupUuid = this.routeParams.optionalGroupUuid;
    return await OptionalGroupRepository.updateOptionalGroup(
      optionalGroupUuid,
      params
    );
  }
}

export default OptionalGroupFormEditPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/optional-groups/form/edit.presenter.js